/** Statsig gate for the shipment File Upload Queue. The id is still to be confirmed in the UAC. */
export const FILE_UPLOAD_QUEUE_GATE = 'file-upload-queue-v1'

/**
 * @param {object | null | undefined} statsigClient - Statsig client from `useStatsigClient()`.
 * @returns {boolean} Whether Add Temp Data and Add data open the File Upload Queue.
 */
export const isFileUploadQueueEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(FILE_UPLOAD_QUEUE_GATE))
